import { useMemo } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import ReactJson from '@microlink/react-json-view';

const Section = ({ title, src, name, collapsed = false, themeName }) => (
  <Stack spacing={1}>
    <Typography variant="h3">{title}</Typography>
    <Box
      sx={{
        p: 2,
        borderRadius: 1,
        bgcolor: 'action.hover',
        '& .react-json-view': { bgcolor: 'transparent !important' },
      }}
    >
      <ReactJson
        src={src ?? {}}
        name={name}
        collapsed={collapsed}
        sortKeys
        displayDataTypes={false}
        theme={themeName}
        style={{ background: 'transparent' }}
      />
    </Box>
  </Stack>
);

const AccountDataJsonSections = ({ accountDataJson }) => {
  const theme = useTheme();
  const jsonViewTheme = theme.palette.mode === 'dark' ? 'monokai' : 'rjv-default';

  const get = (field) =>
    Object.prototype.hasOwnProperty.call(accountDataJson, field)
      ? accountDataJson[field]
      : null;

  const sections = useMemo(
    () => [
      {
        title: 'Account Overview',
        name: 'Account Overview',
        src: {
          ID: get('id'),
          'Account Type': get('type'),
          'Hierarchy Status': get('verticalType'),
          'Company Name': get('name'),
          'Live URL': get('url'),
          'CMS URL': get('internalUrl'),
        },
      },
      {
        title: 'DNA Section',
        name: 'DNA',
        src: {
          'Features List': get('grantedResources'),
          'Dealer Code Mappings': get('dealerCodes'),
        },
      },
      {
        title: 'Group Information',
        name: 'Group Info',
        src: {
          'Ancestor AccountIDs': get('ancestorAccountIds'),
          'Descendant AccountIDs': get('descendantAccountIds'),
          'Child AccountIDs': get('childAccountIds'),
          'Parent AccountIDs': get('parentAccountIds'),
        },
      },
      {
        title: 'Dealership Information',
        name: 'Dealership Info',
        src: {
          Address: get('address'),
          'Primary Contact Information': get('primaryContactInformation'),
          Hours: get('hours'),
          'Department Info': get('departments'),
          'Franchise List': get('franchiseList'),
        },
      },
      {
        title: 'Inventory Configuration',
        name: 'Inventory Config',
        src: { 'Inventory Config': get('inventoryListingConfigs') },
        collapsed: 1,
      },
    ],
    [accountDataJson]
  );

  return (
    <Stack spacing={2}>
      {sections.map((s) => (
        <Section key={s.title} {...s} themeName={jsonViewTheme} />
      ))}
    </Stack>
  );
};

export default AccountDataJsonSections;
